<app-page [dynamicHeight]="true" class="page-wrapper">
  <app-header>
    <h1 app-overline>Create simulation</h1>
    <h2 app-title>Select Software Configurations</h2>

    <app-header-actions>
      <button
        *appIfCommandAvailable="'create_software'"
        mat-raised-button
        pally-rounded-button-m
        color="primary"
        (click)="createSwConfig()"
      >
        <mat-icon>add</mat-icon>Create
      </button>
    </app-header-actions>
  </app-header>

  <ng-container *ngIf="swPresetsTableData$ | async as presetData">
    <!-- Loading state -->
    <app-loading *ngIf="presetData.isLoading"></app-loading>

    <!-- Error state -->
    <app-error
      *ngIf="presetData.error as error"
      [error]="error"
      [hideActions]="true"
    ></app-error>

    <!-- Presets table -->
    <mat-expansion-panel
      (opened)="presetsExpanded = true"
      (closed)="presetsExpanded = false"
      [expanded]="presetsExpanded"
    >
      <mat-expansion-panel-header>
        <mat-panel-title
          style="font-weight: 500; font-size: 18px; text-transform: capitalize"
        >
          Software configuration presets
        </mat-panel-title>
      </mat-expansion-panel-header>

      <app-table
        *ngIf="presetData.didSucceed"
        [clickableRows]="true"
        [clickToSelect]="true"
        [topRow]="false"
        [inputData]="presetData.value"
        [preSelectedRows]="father.zimWizard.getSelected('softwarePresets')"
        [displayedColumns]="columnsToDisplay"
        (blockSelectedChange)="father.zimWizard.editSoftwarePresets($event)"
      ></app-table>
    </mat-expansion-panel>
  </ng-container>

  <ng-container *ngIf="swTableData$ | async as data">
    <!-- Loading state -->
    <app-loading *ngIf="data.isLoading"></app-loading>

    <!-- Error state -->
    <app-error
      *ngIf="data.error as error"
      [error]="error"
      [hideActions]="true"
    ></app-error>

    <!-- User configs table-->
    <mat-expansion-panel style="margin-top: 1em">
      <mat-expansion-panel-header>
        <mat-panel-title
          style="font-weight: 500; font-size: 18px; text-transform: capitalize"
        >
          Your software configurations
        </mat-panel-title>
      </mat-expansion-panel-header>

      <app-table
        #table
        *ngIf="data.didSucceed"
        [clickableRows]="true"
        [clickToSelect]="true"
        [topRow]="false"
        [inputData]="data.value"
        [preSelectedRows]="father.zimWizard.getSelected('softwares')"
        [displayedColumns]="columnsToDisplay"
        [actions]="true"
        (actionClicked)="actionClicked($event)"
        (blockSelectedChange)="father.zimWizard.editSoftwares($event)"
      ></app-table>
    </mat-expansion-panel>
  </ng-container>
</app-page>
